export const DEFAULT_SCALE = 13;
export const POINTS_LIMIT = 30000;
export const MAX_SPEED = 16;

export const debug = localStorage.getItem('debug')